import PropTypes from 'prop-types';
import React from 'react';
import Slider from 'react-slick';
import classnames from 'classnames';

import {
  breakpointSMInt,
  breakpointMDInt,
  breakpointLGInt,
} from '../../base-styles/vars';

import { PrevArrow, NextArrow } from './components/Arrow';

import styles from './styles.css'; // eslint-disable-line no-unused-vars

// Breakpoint settings are string vars for min-width e.g. '768px'
// Slider is looking for ints for max-widths, e.g. 767
const breakpoints = {
  XS: breakpointSMInt - 1,
  SM: breakpointMDInt - 1,
  MD: breakpointLGInt - 1,
};

/**
 * Carousel presentational component.
 * Configures defaults and styles React Slick slider.
 *
 * We apply responsive settings only when component is mounted, otherwise
 * checksum is invalid when CLIENT is smaller than fullwidth (SSR).
 * This bug is supposed to be fixed but still occurs in our case...
 * Check progress here:
 * https://github.com/akiran/react-slick/issues/776
 */
class Carousel extends React.Component {
  constructor() {
    super();
    this.state = {};
  }

  componentDidMount() {
    // eslint-disable-next-line react/no-did-mount-set-state
    this.setState({
      isMounted: true,
    });
  }

  render() {
    const {
      children,
      settingsXS,
      settingsSM,
      settingsMD,
      smallArrow,
      className,
      dots = false,
      ...props
    } = this.props;

    const responsiveSettings = [];

    if (this.state.isMounted) {
      if (settingsXS) {
        responsiveSettings.push({
          breakpoint: breakpoints.XS,
          settings: settingsXS,
        });
      }
      if (settingsSM) {
        responsiveSettings.push({
          breakpoint: breakpoints.SM,
          settings: settingsSM,
        });
      }
      if (settingsMD) {
        responsiveSettings.push({
          breakpoint: breakpoints.MD,
          settings: settingsMD,
        });
      }
    }
    // key on Slider is used to force full rerender
    return (
      <div className={classnames('carouselComponent', className)}>
        <Slider
          key={this.state.isMounted}
          dots={dots}
          lazyLoad
          infinite={false}
          responsive={responsiveSettings}
          speed={500}
          nextArrow={
            <NextArrow small={smallArrow} className="slick-disabled" />
          }
          prevArrow={
            <PrevArrow small={smallArrow} className="slick-disabled" />
          }
          {...props}
        >
          {children}
        </Slider>
      </div>
    );
  }
}

Carousel.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
  /**
   * Object of settings to use up to SM breakpoint.
   */
  settingsSM: PropTypes.shape(),
  /**
   * Object of settings to use up to MD breakpoint.
   */
  settingsMD: PropTypes.shape(),
  smallArrow: PropTypes.bool,
};

Carousel.defaultProps = {
  settingsSM: undefined,
  settingsMD: undefined,
  smallArrow: false,
};

export default Carousel;
